import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

const Quiz = ({ item }) => {
    const { id, name, logo, total } = item;

    return (
        <div className="space-y-4">
            <img alt="" className="object-cover h-56 mx-auto mb-4 bg-center rounded-sm dark:bg-gray-500" src={logo} />
            <div className="flex flex-col items-center">
                <h4 className="text-xl font-semibold">{name}</h4>
                <p className="text-sm dark:text-gray-400 my-5">Total {name} Quiz: {total}</p>
                <Link to={`/quiztopic/${id}`} className="px-4 py-2 text-lg font-semibold dark:bg-purple-400 dark:text-gray-900 rounded-md hover:bg-blue-600 hover:text-white">Start Quiz
                    <FontAwesomeIcon icon={faEye} className="ml-3"></FontAwesomeIcon>
                </Link>
            </div>
        </div>
    );
};

export default Quiz;